import { InvestmentVisibilityType } from '@/types';

export interface InvestmentDraftValues {
    value?: string;
    visibility?: InvestmentVisibilityType;
}

const investmentVisibilityValues = new Set<string>(Object.values(InvestmentVisibilityType));

export const parseInvestmentDraftValues = (values: unknown): InvestmentDraftValues => {
    if (!values || typeof values !== 'object') {
        return {};
    }

    const candidate = values as Record<string, unknown>;

    return {
        value: typeof candidate.value === 'string' ? candidate.value : undefined,
        visibility: investmentVisibilityValues.has(String(candidate.visibility))
            ? (candidate.visibility as InvestmentVisibilityType)
            : undefined,
    };
};
